
export const tours = [
  {
    id: 1,
    title: "Brooklyn Heights Historical Cat Tour",
    description: "Explore America's first suburb through its feline residents. From the Brooklyn Bridge's cat supervisor to the Heights' famous feline celebrities that charmed literary figures.",
    image: "/lovable-uploads/0a57130d-68ab-4a75-b052-cfeffcf79b78.png",
    bookingUrl: "https://fareharbor.com/embeds/book/catsabouttown/items/562630/calendar/?flow=1219724&full-items=yes",
    featured: true,
    itemId: 562630,
    teaser: "You'll hear how Ned the cat crossed the Brooklyn Bridge before humans ever traversed it..."
  },
  {
    id: 2,
    title: "Financial District Historical Cat Tour",
    description: "Explore the alleys where ship cats first arrived in New York Harbor. Discover the Wall Street mouser who saved priceless documents during the Great Fire of 1835.",
    image: "/lovable-uploads/a84bf898-e5af-4eb7-bd42-b0739d09537c.png",
    bookingUrl: "https://fareharbor.com/embeds/book/catsabouttown/items/577800/calendar/?flow=1219724&full-items=yes",
    itemId: 577800,
    teaser: "Meet the cats who guarded Wall Street's fortunes and helped shape America's financial center."
  },
  {
    id: 3,
    title: "Lower East Side Historical Cat Tour",
    description: "Meet the immigrant cats who lived alongside their human families in tenements. Learn how the bodega cats tradition began in this cultural melting pot.",
    image: "/lovable-uploads/d50c44ab-fa90-46fd-9421-79e3007adbe0.png",
    bookingUrl: "https://fareharbor.com/embeds/book/catsabouttown/items/604533/calendar/?flow=1219724&full-items=yes",
    itemId: 604533,
    teaser: "Discover how immigrant families and their cats adapted to life in America's most densely populated neighborhood."
  },
  {
    id: 4,
    title: "Private Tours",
    description: "Book a private tour for your group! We can customize the tour to your interests and schedule.",
    image: "/lovable-uploads/bd21f9ef-b1f2-4bd5-b145-a694d400d436.png",
    bookingUrl: "https://fareharbor.com/embeds/book/catsabouttown/items/562633/calendar/?flow=1219724&full-items=yes",
    itemId: 562633
  }
];

export const faqs = [
  {
    question: "What is the duration of the tour?",
    answer: "The tour typically lasts for approximately 2 hours, covering a distance of about 1.5 miles at a leisurely pace."
  },
  {
    question: "Is the tour wheelchair accessible?",
    answer: "Unfortunately, due to the historic nature of the neighborhood and some uneven sidewalks, the tour is not fully wheelchair accessible. Please contact us for more information."
  },
  {
    question: "Are there any discounts available?",
    answer: "We offer discounts for students, seniors, and groups of 10 or more. Please contact us for more information."
  },
  {
    question: "What should I bring on the tour?",
    answer: "We recommend bringing comfortable shoes, water, and a camera to capture the purr-fect moments. Don't forget to check the weather forecast and dress accordingly!"
  },
  {
    question: "Are there restrooms available during the tour?",
    answer: "Restrooms are available at the beginning and end of the tour. There are also public restrooms available along the route."
  }
];

// Add story teaser to the Brooklyn Heights tour - make sure this matches your existing tours array structure
const updatedTours = tours.map(tour => {
  if (tour.title.includes("Brooklyn Heights")) {
    return {
      ...tour, 
      featured: true,
      description: "Explore America's first suburb through its feline residents. From the Brooklyn Bridge's cat supervisor to the Heights' famous feline celebrities that charmed literary figures.",
      teaser: "You'll hear how Ned the cat crossed the Brooklyn Bridge before humans ever traversed it..."
    };
  } else if (tour.title.includes("Financial District")) {
    return {
      ...tour,
      description: "Explore the alleys where ship cats first arrived in New York Harbor. Discover the Wall Street mouser who saved priceless documents during the Great Fire of 1835.",
      teaser: "Meet the cats who guarded Wall Street's fortunes and helped shape America's financial center."
    };
  } else if (tour.title.includes("Lower East Side")) {
    return {
      ...tour,
      description: "Meet the immigrant cats who lived alongside their human families in tenements. Learn how the bodega cats tradition began in this cultural melting pot.",
      teaser: "Discover how immigrant families and their cats adapted to life in America's most densely populated neighborhood."
    };
  }
  return tour;
});
